import { render } from "./hotelBoking.vue?vue&type=template&id=3561674d"
import script from "./hotelBoking.vue?vue&type=script&lang=js"
export * from "./hotelBoking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__